module.exports = "/_next/static/images/007486d52258cf79b772cf9c4cfcbeff-estadao.png.webp";